import React from 'react';
import { Loader } from '../../components';

export default React.createClass({
  render(){
    return <div className="page-loader fade in"><Loader>Page loading, please wait.</Loader></div>
  }
});
